export enum LANGUAGES {
  uz = "uz",
  ru = "ru",
}
